import { render, staticRenderFns } from "./ScrollTopBtn.vue?vue&type=template&id=a4bed39e&"
import script from "./ScrollTopBtn.vue?vue&type=script&lang=js&"
export * from "./ScrollTopBtn.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTopBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/mgrunwald/Projects/Vue.js/playground/movie-app-dev/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
